//Splide SupportYou
import Splide from "@splidejs/splide";

const classExists = document.getElementsByClassName('supportYou').length > 0;

if (classExists) {
    var splide = new Splide('.supportYou', {
        //type   : 'loop',
        type  : 'fade',
        rewind: true,
        focus: 'center',
        lazyLoad: 'nearby',
        drag: false,
    });


    splide.on( 'pagination:mounted', function ( data ) {
        // You can add your class to the UL element
        data.list.classList.add( 'splide__pagination--custom' );
        
        // `items` contains all dot items
        data.items.forEach( function ( item ) {
            var nameSlide = document.getElementById(item.button.attributes['3'].value).getElementsByTagName('h2')['0'].innerHTML;
            item.button.textContent = String( "0"+(item.page+1)+" • "+nameSlide );
        } );
    } );

    splide.mount();

    const divs = document.querySelectorAll('.buttonChange');
    divs.forEach(el => el.addEventListener('click', event => {
        if (el.getAttribute("data-button") == 'prev') {
            document.querySelector(".supportYou .splide__arrow--prev").click();
        } else {
            document.querySelector(".supportYou .splide__arrow--next").click();
        }
    }));
}